import React, { useState } from "react";
import {
  IconButton,
  Popover,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
  ListItemButton,
  Box,
  useTheme,
  darken,
  Link
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  OLD_APP_HOME_URL,
  OLD_APP_LOGOUT_URL
} from "../../../constants/potato";

export const DrawerUserInformation = ({ email }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "user-information-popover" : undefined;
  const name = email?.split("@")[0] ?? "there";

  return (
    <Box
      paddingX="12px"
      backgroundColor={darken(theme.palette.primary.dark, 0.05)}
    >
      <Divider />
      <Box
        display="flex"
        gap="8px"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography textTransform="capitalize">Hey {name}! 🎉</Typography>
        <IconButton onClick={handleOpen} aria-describedby={id}>
          <AccountCircleIcon sx={{ fontSize: 32 }} />
        </IconButton>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <List disablePadding>
          <ListItem disablePadding>
            <ListItemButton
              component={Link}
              href={OLD_APP_HOME_URL}
              aria-label="Go to old potato"
            >
              <ListItemText>Access old potato</ListItemText>
            </ListItemButton>
          </ListItem>
          <Divider />
          <ListItem disablePadding>
            <ListItemButton component={Link} href={OLD_APP_LOGOUT_URL}>
              <ListItemText>Logout</ListItemText>
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>
    </Box>
  );
};

export default DrawerUserInformation;
